import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/chatbot.css';

const ChatbotButton = () => {
  const navigate = useNavigate();

  return (
    <button className="chatbot-button" onClick={() => navigate('/chat')}>
      <span>💬</span> Chat
    </button>
  );
};

export default ChatbotButton;
